import {
  CLEAN_ERROR,
  CREATE_HOST_CAPACITY_INSTANCE,
  CREATE_HOST_CAPACITY_INSTANCE_IS_ERROR,
  CREATE_HOST_CAPACITY_INSTANCE_IS_PENDING,
  CREATE_HOST_CAPACITY_TEMPLATE,
  CREATE_HOST_CAPACITY_TEMPLATE_IS_ERROR,
  CREATE_HOST_CAPACITY_TEMPLATE_IS_PENDING,
  DELETE_HOST_CAPACITY_INSTANCE,
  DELETE_HOST_CAPACITY_INSTANCE_IS_ERROR,
  DELETE_HOST_CAPACITY_INSTANCE_IS_PENDING,
  DELETE_HOST_CAPACITY_TEMPLATE,
  DELETE_HOST_CAPACITY_TEMPLATE_IS_ERROR,
  DELETE_HOST_CAPACITY_TEMPLATE_IS_PENDING,
  FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES,
  FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES_IS_ERROR,
  FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES_IS_PENDING,
  FETCH_HOST_TEMPLATE,
  FETCH_HOST_TEMPLATE_BY_ID,
  FETCH_HOST_TEMPLATE_BY_ID_IS_ERROR,
  FETCH_HOST_TEMPLATE_BY_ID_IS_PENDING,
  FETCH_HOST_TEMPLATE_IS_ERROR,
  FETCH_HOST_TEMPLATE_IS_PENDING,
  SKIP_FETCH,
  SORT,
  UPDATE_HOST_CAPACITY_INSTANCE,
  UPDATE_HOST_CAPACITY_INSTANCE_IS_ERROR,
  UPDATE_HOST_CAPACITY_INSTANCE_IS_PENDING,
  UPDATE_HOST_CAPACITY_TEMPLATE,
  UPDATE_HOST_CAPACITY_TEMPLATE_IS_ERROR,
  UPDATE_HOST_CAPACITY_TEMPLATE_IS_PENDING,
} from 'services/GameHosting/DeploymentTemp/HostCapacity/types';
import { addNew, sort } from 'utils/functions';

const INITIAL_STATE = {
  hostDepTemp: [],
  sortBy: 'name',
  sortDirection: 'ASC',
  params: {},
  hostTemplate: {},
  hostTemplateInstances: [],
};

const CUD_STATE = {
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,

  fetchByIdIsCompleted: false,
  fetchByIdIsPending: false,
  fetchByIdIsError: null,

  fetchHostTemplateInstancesIsCompleted: false,
  fetchHostTemplateInstancesIsPending: false,
  fetchHostTemplateInstancesIsError: null,

  createIsCompleted: false,
  createIsPending: false,
  createIsError: null,

  updateIsCompleted: false,
  updateIsPending: false,
  updateIsError: null,

  deleteIsCompleted: false,
  deleteIsPending: false,
  deleteIsError: null,

  createHostCapacityInstanceIsCompleted: false,
  createHostCapacityInstanceIsPending: false,
  createHostCapacityInstanceIsError: null,

  updateHostCapacityInstanceIsCompleted: false,
  updateHostCapacityInstanceIsPending: false,
  updateHostCapacityInstanceIsError: null,

  deleteHostCapacityInstanceIsCompleted: false,
  deleteHostCapacityInstanceIsPending: false,
  deleteHostCapacityInstanceIsError: null,
};

const hostTemplateReducer = (
  state = {
    ...INITIAL_STATE,
    ...CUD_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case SKIP_FETCH:
      return {
        ...state,
        fetchHostTemplateInstancesIsCompleted: true,
      };
    case FETCH_HOST_TEMPLATE:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        hostDepTemp: sort(action.data, {
          sortBy: state.sortBy,
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortDirection: state.sortDirection,
          sortSearchValue: (state.params as $TSFixMe).sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_HOST_TEMPLATE_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_HOST_TEMPLATE_IS_ERROR:
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchIsError: action.error,
      };
    case FETCH_HOST_TEMPLATE_BY_ID:
      return {
        ...state,
        hostTemplate: {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          ...action.data,
        },
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: null,
      };
    case FETCH_HOST_TEMPLATE_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchByIdIsCompleted: false,
        fetchByIdIsPending: true,
        fetchByIdIsError: null,
      };
    case FETCH_HOST_TEMPLATE_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchByIdIsError: action.error,
      };
    case FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        hostTemplateInstances: action.data,
        fetchHostTemplateInstancesIsCompleted: true,
        fetchHostTemplateInstancesIsPending: false,
        fetchHostTemplateInstancesIsError: null,
      };
    case FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES_IS_PENDING:
      return {
        ...state,
        fetchHostTemplateInstancesIsCompleted: false,
        fetchHostTemplateInstancesIsPending: true,
        fetchHostTemplateInstancesIsError: null,
      };
    case FETCH_HOST_CAPACITY_TEMPLATE_INSTANCES_IS_ERROR:
      return {
        ...state,
        fetchHostTemplateInstancesIsCompleted: true,
        fetchHostTemplateInstancesIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchHostTemplateInstancesIsError: action.error,
      };

    case CREATE_HOST_CAPACITY_TEMPLATE: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        hostDepTemp: addNew(action.data, state.hostDepTemp),
        createIsCompleted: true,
        createIsPending: false,
        createIsError: null,
      };
    }

    case CREATE_HOST_CAPACITY_TEMPLATE_IS_PENDING:
      return {
        ...state,
        createIsCompleted: false,
        createIsPending: true,
        createIsError: null,
      };
    case CREATE_HOST_CAPACITY_TEMPLATE_IS_ERROR:
      return {
        ...state,
        createIsCompleted: false,
        createIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        createIsError: action.error,
      };

    case UPDATE_HOST_CAPACITY_TEMPLATE: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const indexToUpdate = state.hostDepTemp.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        hostDepTemp: state.hostDepTemp.map((item, index) => {
          if (index !== indexToUpdate) {
            return item;
          }

          return {
            // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
            ...item,

            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ...action.data,
          };
        }),
        updateIsCompleted: true,
        updateIsPending: false,
        updateIsError: null,
      };
    }

    case UPDATE_HOST_CAPACITY_TEMPLATE_IS_PENDING:
      return {
        ...state,
        updateIsCompleted: false,
        updateIsPending: true,
        updateIsError: null,
      };
    case UPDATE_HOST_CAPACITY_TEMPLATE_IS_ERROR:
      return {
        ...state,
        updateIsCompleted: false,
        updateIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateIsError: action.error,
      };

    case DELETE_HOST_CAPACITY_TEMPLATE: {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const index = state.hostDepTemp.findIndex((x) => (x as $TSFixMe).id === action.data.id);

      return {
        ...state,
        hostDepTemp: [...state.hostDepTemp.slice(0, index), ...state.hostDepTemp.slice(index + 1)],
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: null,
      };
    }

    case DELETE_HOST_CAPACITY_TEMPLATE_IS_PENDING:
      return {
        ...state,
        deleteIsCompleted: false,
        deleteIsPending: true,
        deleteIsError: null,
      };
    case DELETE_HOST_CAPACITY_TEMPLATE_IS_ERROR:
      return {
        ...state,
        deleteIsCompleted: true,
        deleteIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        deleteIsError: action.error,
      };
    case CREATE_HOST_CAPACITY_INSTANCE:
      return {
        ...state,
        createHostCapacityInstanceIsCompleted: true,
        createHostCapacityInstanceIsPending: false,
        createHostCapacityInstanceIsError: null,
      };
    case CREATE_HOST_CAPACITY_INSTANCE_IS_PENDING:
      return {
        ...state,
        createHostCapacityInstanceIsCompleted: false,
        createHostCapacityInstanceIsPending: true,
        createHostCapacityInstanceIsError: null,
      };
    case CREATE_HOST_CAPACITY_INSTANCE_IS_ERROR:
      return {
        ...state,
        createHostCapacityInstanceIsCompleted: true,
        createHostCapacityInstanceIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        createHostCapacityInstanceIsError: action.error,
      };
    case UPDATE_HOST_CAPACITY_INSTANCE:
      return {
        ...state,
        updateHostCapacityInstanceIsCompleted: true,
        updateHostCapacityInstanceIsPending: false,
        updateHostCapacityInstanceIsError: null,
      };
    case UPDATE_HOST_CAPACITY_INSTANCE_IS_PENDING:
      return {
        ...state,
        updateHostCapacityInstanceIsCompleted: false,
        updateHostCapacityInstanceIsPending: true,
        updateHostCapacityInstanceIsError: null,
      };
    case UPDATE_HOST_CAPACITY_INSTANCE_IS_ERROR:
      return {
        ...state,
        updateHostCapacityInstanceIsCompleted: true,
        updateHostCapacityInstanceIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateHostCapacityInstanceIsError: action.error,
      };
    case DELETE_HOST_CAPACITY_INSTANCE:
      return {
        ...state,
        deleteHostCapacityInstanceIsCompleted: true,
        deleteHostCapacityInstanceIsPending: false,
        deleteHostCapacityInstanceIsError: null,
      };
    case DELETE_HOST_CAPACITY_INSTANCE_IS_PENDING:
      return {
        ...state,
        deleteHostCapacityInstanceIsCompleted: false,
        deleteHostCapacityInstanceIsPending: true,
        deleteHostCapacityInstanceIsError: null,
      };
    case DELETE_HOST_CAPACITY_INSTANCE_IS_ERROR:
      return {
        ...state,
        deleteHostCapacityInstanceIsCompleted: true,
        deleteHostCapacityInstanceIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        deleteHostCapacityInstanceIsError: action.error,
      };
    case SORT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        hostDepTemp: sort(state.hostDepTemp, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };
    case CLEAN_ERROR:
      return {
        ...state,
        fetchIsError: null,
      };
    case 'RESET_HOST_CAPACITY_REDUCER':
    case 'RESET_REDUCER':
      return {
        ...INITIAL_STATE,
        ...CUD_STATE,
      };
    default:
      return state;
  }
};

export default hostTemplateReducer;
